"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRetryType = void 0;
var PaymentRetryType;
(function (PaymentRetryType) {
    PaymentRetryType["Automatic"] = "automatic";
    PaymentRetryType["Manual"] = "manual";
})(PaymentRetryType = exports.PaymentRetryType || (exports.PaymentRetryType = {}));
//# sourceMappingURL=RetryWritebackJobInput.js.map